import React, { useState, useRef } from 'react';
import { MessageCircle, Users, Plus, Send, Smile, Paperclip, ImageIcon, CheckCircle, Clock, Heart, Gift, X, ChevronDown, Settings, Bell, BellOff, Lock, Video, Mic } from 'lucide-react';
const MultiAngelGroupChat: React.FC = () => {
  const [activeChat, setActiveChat] = useState('group1');
  const [message, setMessage] = useState('');
  const [showChatInfo, setShowChatInfo] = useState(false);
  const [showAddAngels, setShowAddAngels] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  // Sample chat groups
  const chatGroups = [{
    id: 'group1',
    name: 'Fantasy Trio',
    angels: [{
      id: 'angel1',
      name: 'Sophia',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png',
      online: true
    }, {
      id: 'angel2',
      name: 'Eva',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nBpXopQ7YXWmZqdTwR7HaM/image.png',
      online: true
    }, {
      id: 'angel3',
      name: 'Riley',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2myPwGWmEWGW4CWiQgdDdz/image.png',
      online: false
    }],
    lastActive: '2 min ago',
    messages: [{
      id: 'msg1',
      sender: {
        id: 'angel1',
        name: 'Sophia',
        avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png'
      },
      content: 'Hey there! Eva and I were just talking about you! 😘',
      timestamp: '10:30 AM',
      status: 'read'
    }, {
      id: 'msg2',
      sender: {
        id: 'angel2',
        name: 'Eva',
        avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nBpXopQ7YXWmZqdTwR7HaM/image.png'
      },
      content: 'Yes! We were planning something special for our next group session... 😏',
      timestamp: '10:31 AM',
      status: 'read'
    }, {
      id: 'msg3',
      sender: {
        id: 'user',
        name: 'You',
        avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ghDUMPkgu6vB5tAeLS5XJy/image.png'
      },
      content: "Oh really? I'm intrigued... what do you have in mind?",
      timestamp: '10:32 AM',
      status: 'delivered'
    }, {
      id: 'msg4',
      sender: {
        id: 'angel1',
        name: 'Sophia',
        avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png'
      },
      content: 'Well, we know how much you enjoy watching us together... so we thought maybe we could try that new toy you bought us? 💦',
      timestamp: '10:33 AM',
      status: 'read'
    }, {
      id: 'msg5',
      sender: {
        id: 'angel3',
        name: 'Riley',
        avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2myPwGWmEWGW4CWiQgdDdz/image.png'
      },
      content: "Hey everyone! Sorry I'm late to the chat. Did I miss anything fun? 😊",
      timestamp: '10:36 AM',
      status: 'read'
    }, {
      id: 'msg6',
      sender: {
        id: 'angel2',
        name: 'Eva',
        avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nBpXopQ7YXWmZqdTwR7HaM/image.png'
      },
      content: 'Riley! Perfect timing. We were just telling him about our plans for Friday... 😏',
      timestamp: '10:37 AM',
      status: 'read'
    }, {
      id: 'msg7',
      sender: {
        id: 'user',
        name: 'You',
        avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ghDUMPkgu6vB5tAeLS5XJy/image.png'
      },
      content: "This is getting interesting. Three of you at once? I don't know if I can handle that 😅",
      timestamp: '10:38 AM',
      status: 'delivered'
    }, {
      id: 'msg8',
      sender: {
        id: 'angel1',
        name: 'Sophia',
        avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png'
      },
      content: "Don't worry, we'll take good care of you... especially with those supplements you've been taking 😘",
      timestamp: '10:39 AM',
      status: 'read'
    }],
    unreadCount: 0
  }, {
    id: 'group2',
    name: 'VIP Experience',
    angels: [{
      id: 'angel4',
      name: 'Jasmine',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cbRc9jayz6abrUqY99QsFF/pasted-image.jpg',
      online: true
    }, {
      id: 'angel5',
      name: 'Bonny Blue',
      avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
      online: false
    }],
    lastActive: '1 hour ago',
    messages: [],
    unreadCount: 3,
    locked: true
  }];
  // Available angels to add
  const availableAngels = [{
    id: 'angel6',
    name: 'Kim Holland',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    specialty: 'Roleplay Expert',
    tokens: 5
  }, {
    id: 'angel7',
    name: 'Mia Khalifa',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rniFdMuqf7v6dkhQTxAkvZ/image.png',
    specialty: 'Domination',
    tokens: 10
  }, {
    id: 'angel8',
    name: 'Bella Blue',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rniFdMuqf7v6dkhQTxAkvZ/image.png',
    specialty: 'Submissive',
    tokens: 5
  }];
  const activeGroupChat = chatGroups.find(group => group.id === activeChat);
  const handleSendMessage = () => {
    if (!message.trim()) return;
    // Add the message to the current chat
    const updatedGroups = chatGroups.map(group => {
      if (group.id === activeChat) {
        return {
          ...group,
          messages: [...group.messages, {
            id: `msg${Date.now()}`,
            sender: {
              id: 'user',
              name: 'You',
              avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ghDUMPkgu6vB5tAeLS5XJy/image.png'
            },
            content: message,
            timestamp: new Date().toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit'
            }),
            status: 'sending'
          }]
        };
      }
      return group;
    });
    // Update the state
    // In a real app, you would use a state management solution
    // For this demo, we'll just simulate it
    setMessage('');
    // Scroll to bottom
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({
        behavior: 'smooth'
      });
    }, 100);
  };
  const formatTime = (timestamp: string) => {
    return timestamp;
  };
  return <div className="w-full bg-white dark:bg-gray-950 text-gray-800 dark:text-white pb-20" data-id="element-14948">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 p-4" data-id="element-14949">
        <div className="flex items-center justify-between" data-id="element-14950">
          <div className="flex items-center gap-3" data-id="element-14951">
            <div className="relative" data-id="element-14952">
              <div className="flex -space-x-2" data-id="element-14953">
                {activeGroupChat?.angels.slice(0, 2).map(angel => <div key={angel.id} className="w-8 h-8 rounded-full overflow-hidden border-2 border-white dark:border-gray-900" data-id="element-14954">
                    <img src={angel.avatar} alt={angel.name} className="w-full h-full object-cover" data-id="element-14955" />
                  </div>)}
              </div>
              <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-pink-500 rounded-full flex items-center justify-center text-[10px] text-white border-2 border-white dark:border-gray-900" data-id="element-14956">
                {activeGroupChat?.angels.length}
              </div>
            </div>
            <div data-id="element-14957">
              <h2 className="font-medium text-gray-800 dark:text-white flex items-center" data-id="element-14958">
                {activeGroupChat?.name}
                {activeGroupChat?.locked && <Lock size={14} className="ml-1 text-pink-500" data-id="element-14959" />}
              </h2>
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-14960">
                {activeGroupChat?.angels.map(a => a.name).join(', ')}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2" data-id="element-14961">
            <button className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-14962">
              <Video size={18} className="text-gray-500 dark:text-gray-400" data-id="element-14963" />
            </button>
            <button className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" onClick={() => setShowChatInfo(!showChatInfo)} data-id="element-14964">
              <Settings size={18} className="text-gray-500 dark:text-gray-400" data-id="element-14965" />
            </button>
          </div>
        </div>
        {/* Chat info panel */}
        {showChatInfo && <div className="mt-3 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 animate-in slide-in-from-top duration-300" data-id="element-14966">
            <div className="flex justify-between items-center mb-2" data-id="element-14967">
              <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-14968">
                Group Chat Settings
              </h3>
              <button className="p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700" onClick={() => setShowChatInfo(false)} data-id="element-14969">
                <X size={16} className="text-gray-500 dark:text-gray-400" data-id="element-14970" />
              </button>
            </div>
            <div className="space-y-3" data-id="element-14971">
              <div className="flex items-center justify-between" data-id="element-14972">
                <div className="flex items-center gap-2" data-id="element-14973">
                  <Bell size={16} className="text-gray-500 dark:text-gray-400" data-id="element-14974" />
                  <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-14975">
                    Notifications
                  </span>
                </div>
                <button className="w-10 h-5 rounded-full bg-pink-500 relative" data-id="element-14976">
                  <span className="absolute top-0.5 right-0.5 w-4 h-4 bg-white rounded-full" data-id="element-14977"></span>
                </button>
              </div>
              <div className="flex items-center justify-between" data-id="element-14978">
                <div className="flex items-center gap-2" data-id="element-14979">
                  <Users size={16} className="text-gray-500 dark:text-gray-400" data-id="element-14980" />
                  <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-14981">
                    Group Members
                  </span>
                </div>
                <button className="text-xs text-pink-500 dark:text-pink-400" onClick={() => {
              setShowChatInfo(false);
              setShowAddAngels(true);
            }} data-id="element-14982">
                  Manage
                </button>
              </div>
              <button className="w-full py-2 mt-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium" data-id="element-14983">
                Start Group Video Call
              </button>
            </div>
          </div>}
      </div>
      {/* Chat groups sidebar for larger screens */}
      <div className="hidden md:block fixed left-20 top-0 bottom-0 w-64 border-r border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 pt-16" data-id="element-14984">
        <div className="p-4 border-b border-gray-200 dark:border-gray-800" data-id="element-14985">
          <h3 className="font-medium text-gray-800 dark:text-white flex items-center justify-between" data-id="element-14986">
            <span data-id="element-14987">Group Chats</span>
            <button className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-14988">
              <Plus size={16} className="text-gray-500 dark:text-gray-400" data-id="element-14989" />
            </button>
          </h3>
        </div>
        <div className="overflow-y-auto h-full pb-20" data-id="element-14990">
          {chatGroups.map(group => <button key={group.id} className={`w-full p-3 flex items-center gap-3 hover:bg-gray-100 dark:hover:bg-gray-800/50 ${activeChat === group.id ? 'bg-gray-100 dark:bg-gray-800/50' : ''}`} onClick={() => setActiveChat(group.id)} data-id="element-14991">
              <div className="relative" data-id="element-14992">
                <div className="flex -space-x-2" data-id="element-14993">
                  {group.angels.slice(0, 2).map(angel => <div key={angel.id} className="w-8 h-8 rounded-full overflow-hidden border-2 border-white dark:border-gray-900" data-id="element-14994">
                      <img src={angel.avatar} alt={angel.name} className="w-full h-full object-cover" data-id="element-14995" />
                    </div>)}
                </div>
                {group.unreadCount > 0 && <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-pink-500 rounded-full flex items-center justify-center text-[10px] text-white border-2 border-white dark:border-gray-900" data-id="element-14996">
                    {group.unreadCount}
                  </div>}
              </div>
              <div className="flex-1 text-left" data-id="element-14997">
                <div className="flex items-center" data-id="element-14998">
                  <h4 className="font-medium text-gray-800 dark:text-white text-sm" data-id="element-14999">
                    {group.name}
                  </h4>
                  {group.locked && <Lock size={12} className="ml-1 text-pink-500" data-id="element-15000" />}
                </div>
                <p className="text-xs text-gray-500 dark:text-gray-400 truncate" data-id="element-15001">
                  {group.angels.map(a => a.name).join(', ')}
                </p>
              </div>
              <span className="text-xs text-gray-400" data-id="element-15002">{group.lastActive}</span>
            </button>)}
        </div>
      </div>
      {/* Messages container */}
      {activeGroupChat?.locked ? <div className="flex flex-col items-center justify-center h-[calc(100vh-120px)] p-4" data-id="element-15003">
          <div className="w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center mb-4" data-id="element-15004">
            <Lock size={24} className="text-pink-500" data-id="element-15005" />
          </div>
          <h3 className="text-lg font-bold text-gray-800 dark:text-white mb-2" data-id="element-15006">
            Premium Group Chat
          </h3>
          <p className="text-center text-gray-600 dark:text-gray-400 mb-4 max-w-md" data-id="element-15007">
            This is a premium group chat experience with our VIP angels. Unlock
            to start chatting with multiple angels at once.
          </p>
          <button className="px-6 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white font-medium" data-id="element-15008">
            Unlock for 10 💎
          </button>
        </div> : <div className="flex-grow overflow-y-auto p-4 space-y-4 h-[calc(100vh-120px)]" data-id="element-15009">
          {activeGroupChat?.messages.map(message => <div key={message.id} className={`flex ${message.sender.id === 'user' ? 'justify-end' : 'justify-start'} gap-2`} data-id="element-15010">
              {message.sender.id !== 'user' && <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0" data-id="element-15011">
                  <img src={message.sender.avatar} alt={message.sender.name} className="w-full h-full object-cover" data-id="element-15012" />
                </div>}
              <div className={`max-w-[75%] p-3 rounded-lg ${message.sender.id === 'user' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white rounded-br-none' : 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white rounded-bl-none'}`} data-id="element-15013">
                {message.sender.id !== 'user' && <div className="flex items-center gap-1 mb-1" data-id="element-15014">
                    <span className="font-medium text-xs text-gray-600 dark:text-gray-400" data-id="element-15015">
                      {message.sender.name}
                    </span>
                  </div>}
                <p className="text-sm" data-id="element-15016">{message.content}</p>
                <div className="mt-1 flex items-center justify-end gap-1" data-id="element-15017">
                  <span className="text-xs text-gray-400 dark:text-gray-500" data-id="element-15018">
                    {formatTime(message.timestamp)}
                  </span>
                  {message.sender.id === 'user' && <>
                      {message.status === 'sending' && <Clock size={12} className="text-gray-300" data-id="element-15019" />}
                      {message.status === 'delivered' && <CheckCircle size={12} className="text-gray-300" data-id="element-15020" />}
                      {message.status === 'read' && <CheckCircle size={12} className="text-blue-400" fill="currentColor" data-id="element-15021" />}
                    </>}
                </div>
              </div>
              {message.sender.id === 'user' && <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0" data-id="element-15022">
                  <img src={message.sender.avatar} alt={message.sender.name} className="w-full h-full object-cover" data-id="element-15023" />
                </div>}
            </div>)}
          <div ref={messagesEndRef} data-id="element-15024" />
        </div>}
      {/* Message input */}
      {!activeGroupChat?.locked && <div className="sticky bottom-0 border-t border-gray-200 dark:border-gray-800 p-3 bg-white dark:bg-gray-900" data-id="element-15025">
          <div className="relative" data-id="element-15026">
            <div className="absolute left-3 top-1/2 -translate-y-1/2 flex items-center gap-1" data-id="element-15027">
              <button className="p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-15028">
                <Paperclip size={18} className="text-gray-500 dark:text-gray-400" data-id="element-15029" />
              </button>
            </div>
            <input type="text" className="w-full bg-gray-100 dark:bg-gray-800 rounded-full pl-16 pr-12 py-3 text-sm focus:outline-none focus:ring-1 focus:ring-pink-500 text-gray-800 dark:text-gray-200" placeholder="Message group..." value={message} onChange={e => setMessage(e.target.value)} onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
          }
        }} data-id="element-15030" />
            <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1" data-id="element-15031">
              <button className="p-1.5 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700" data-id="element-15032">
                <Smile size={18} className="text-gray-500 dark:text-gray-400" data-id="element-15033" />
              </button>
              <button className="p-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full disabled:opacity-50 disabled:cursor-not-allowed" disabled={!message.trim()} onClick={handleSendMessage} data-id="element-15034">
                <Send size={18} className="text-white" data-id="element-15035" />
              </button>
            </div>
          </div>
          <div className="mt-2 flex justify-between" data-id="element-15036">
            <div className="flex -space-x-2" data-id="element-15037">
              {activeGroupChat?.angels.map(angel => <div key={angel.id} className="w-6 h-6 rounded-full overflow-hidden border-2 border-white dark:border-gray-900 relative" data-id="element-15038">
                  <img src={angel.avatar} alt={angel.name} className="w-full h-full object-cover" data-id="element-15039" />
                  {angel.online && <div className="absolute bottom-0 right-0 w-2 h-2 bg-green-500 rounded-full border border-white dark:border-gray-900" data-id="element-15040"></div>}
                </div>)}
              <button className="w-6 h-6 rounded-full bg-gray-200 dark:bg-gray-800 flex items-center justify-center border-2 border-white dark:border-gray-900" data-id="element-15041">
                <Plus size={12} className="text-gray-500 dark:text-gray-400" data-id="element-15042" />
              </button>
            </div>
            <div className="flex items-center gap-2" data-id="element-15043">
              <button className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-15044">
                <Gift size={16} className="text-pink-500" data-id="element-15045" />
              </button>
              <button className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-15046">
                <Heart size={16} className="text-pink-500" data-id="element-15047" />
              </button>
            </div>
          </div>
        </div>}
      {/* Add Angels Modal */}
      {showAddAngels && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-15048">
          <div className="w-full max-w-md bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-15049">
            <div className="p-4 border-b border-gray-200 dark:border-gray-800 flex items-center justify-between" data-id="element-15050">
              <h3 className="font-bold text-gray-800 dark:text-white" data-id="element-15051">
                Add Angels to Group
              </h3>
              <button className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" onClick={() => setShowAddAngels(false)} data-id="element-15052">
                <X size={18} className="text-gray-500 dark:text-gray-400" data-id="element-15053" />
              </button>
            </div>
            <div className="p-4" data-id="element-15054">
              <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-15055">
                Current Members
              </h4>
              <div className="space-y-2 mb-4" data-id="element-15056">
                {activeGroupChat?.angels.map(angel => <div key={angel.id} className="flex items-center justify-between p-2 bg-gray-100 dark:bg-gray-800 rounded-lg" data-id="element-15057">
                    <div className="flex items-center gap-2" data-id="element-15058">
                      <div className="w-8 h-8 rounded-full overflow-hidden" data-id="element-15059">
                        <img src={angel.avatar} alt={angel.name} className="w-full h-full object-cover" data-id="element-15060" />
                      </div>
                      <span className="text-sm text-gray-800 dark:text-white" data-id="element-15061">
                        {angel.name}
                      </span>
                    </div>
                    <button className="text-xs text-red-500" data-id="element-15062">Remove</button>
                  </div>)}
              </div>
              <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-15063">
                Available Angels
              </h4>
              <div className="space-y-2 mb-4" data-id="element-15064">
                {availableAngels.map(angel => <div key={angel.id} className="flex items-center justify-between p-2 bg-gray-100 dark:bg-gray-800 rounded-lg" data-id="element-15065">
                    <div className="flex items-center gap-2" data-id="element-15066">
                      <div className="w-8 h-8 rounded-full overflow-hidden" data-id="element-15067">
                        <img src={angel.avatar} alt={angel.name} className="w-full h-full object-cover" data-id="element-15068" />
                      </div>
                      <div data-id="element-15069">
                        <span className="text-sm text-gray-800 dark:text-white" data-id="element-15070">
                          {angel.name}
                        </span>
                        <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-15071">
                          {angel.specialty}
                        </p>
                      </div>
                    </div>
                    <button className="px-2 py-1 bg-gradient-to-r from-pink-600 to-purple-600 rounded text-xs text-white" data-id="element-15072">
                      Add ({angel.tokens} 💎)
                    </button>
                  </div>)}
              </div>
              <div className="flex gap-2 mt-4" data-id="element-15073">
                <button className="flex-1 py-2 bg-gray-100 dark:bg-gray-800 rounded-lg text-sm text-gray-800 dark:text-gray-200" onClick={() => setShowAddAngels(false)} data-id="element-15074">
                  Cancel
                </button>
                <button className="flex-1 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium" onClick={() => setShowAddAngels(false)} data-id="element-15075">
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>}
      <style jsx data-id="element-15076">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default MultiAngelGroupChat;